import {gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class Life extends PIXI.Container {

  constructor() {
    super();

    this.build();
  }

  build() {
    this.sprite = new PIXI.Sprite(app.game.assets["ui-life"]);
    this.sprite.anchor.set(0, 0.5);
    this.addChild(this.sprite);
  }

  animateLoseLife() {
    if (!this.isLost) {
      this.isLost = true;

      let loseLiveTimeline = gsap.timeline();

      loseLiveTimeline.fromTo(this.sprite, {
          pixi: {
            alpha: 1
          }
        },
        {
          pixi: {
            alpha: 0.5
          },
          duration: 0.35,
          ease: "power1.inOut",
          repeat: 4,
          yoyo: true,
        })

    }
  }

  reset() {
    this.isLost = false;
    this.sprite.alpha = 1;
  }


}
